export default "__VITE_ASSET__1d43687a__"